import { connect } from "react-redux";
import {
  Creators,
  getSynchronizingCustomers,
  getIsSynchronized,
  getCustomersToQuickAdd,
} from "../../../reducer";
import {
  Creators as CustomerCreators,
  getSearchResult as getCustomerSearchResult,
} from "../../../../customer/reducer";
import QuickAdd from "./QuickAdd";

export default connect(
  (state) => ({
    rangeLocation: state.login.location,
    synchronizingCustomers: getSynchronizingCustomers(state),
    synchronized: getIsSynchronized(state),
    searchResult: getCustomerSearchResult(state),
    customersToQuickAdd: getCustomersToQuickAdd(state),
  }),
  (dispatch) => ({
    onSearchCustomerByPhone: (phone) =>
      dispatch(CustomerCreators.searchCustomer(phone, ["phone"])),
    onClearSearchCustomerResult: () =>
      dispatch(CustomerCreators.clearSearchCustomerResult()),
    onQuickAddCustomer: (location, registration) =>
      dispatch(Creators.quickAddCustomer(location, registration)),
    onSynchronizeCustomers: (customers) =>
      dispatch(Creators.synchronizeCustomers(customers)),
    onAddCustomerToQuickAdd: (customer) =>
      dispatch(Creators.addCustomerToQuickAdd(customer)),
    onRemoveCustomerFromQuickAdd: (customerKey) =>
      dispatch(Creators.removeCustomerFromQuickAdd(customerKey)),
    onClearQuickAdd: () => dispatch(Creators.clearQuickAdd()),
  })
)(QuickAdd);



// WEBPACK FOOTER //
// ./src/staff/components/QuickAddDrawer/QuickAdd/index.js